import axios from "axios";
import { loginreq, req,reqGet} from "../axiosFun";

// 查询队伍订单
export const getTeamList = params => {
    return reqGet("get", "/app-yijiu-backstage/getTeamList", params);
};

// 查询队伍订单详情
export const getTeamOrderList = params => {
    return reqGet("get", "/app-yijiu-backstage/getTeamOrderList", params);
};

// 查询队伍表单字段列表 isViewOpenState是否只返回启用的表单 默认为false查所有
export const getAdminTeamFormList = params => {
    return reqGet("get", "/app-yijiu-backstage/getAdminTeamFormList", params);
};



// 订单退款
export const refundOrder = params => {
    return req("post", "/app-yijiu-backstage/refundOrder", params);
  };
  






// WEBPACK FOOTER //
// ./src/api/manage/teamOrder.js